import LayoutComponent from "src/components/user/layout-component";
import HeroContainer from "src/containers/user/hero-container/hero-container";
import SearchBarContainer from "src/containers/user/search-bar-container/search-bar-container";
import TopRankedSchoolsContainer from "src/containers/user/top-ranked-schools-container/top-ranked-schools-container";

function LandingPage() {
  return (
    <LayoutComponent showLogo={true}>
      <div className="h-full bg-zinc-50">
        <HeroContainer />
        <div className="flex flex-col justify-center items-center mt-[220px] mobile:mt-60 gap-28 mobile:gap-[70px]">
          <SearchBarContainer />
          <TopRankedSchoolsContainer />
        </div>
        <div className="h-[625px] mobile:h-[33px]"></div>
      </div>
    </LayoutComponent>
  );
}

export default LandingPage;
